import React from "react"
import ProtectedLayout from "layouts/Protected"
import { PartnersTable } from "../Partials"
import DashboardIcon from "components/Elements/Icons/Dashboard"
import * as PartnerApi from "features/Partner/api/PartnerApi"
import { OCODE_GENDERS_LIST, genderStoreList, MFC_OPERATOR, BC_OPERATOR } from "utils/constants"
import { normalizeBoolean } from "utils/functions"

import { useAuth, useAlert } from "hooks"
import { useTranslation } from "react-i18next"

export const PartnerCollection = () => {
    const [partners, setPartners] = React.useState(null)
    const { alert } = useAlert()
    const { t } = useTranslation()
    const { user, entity, logout } = useAuth()

    const fetchData = React.useCallback(
        () => {
            ; (async () => {
                try {
                    const { res: getPartners, getError } = await PartnerApi.getPartners("1,2")

                    if (getError()) throw getError()
                    const newPartners = 
                        getPartners
                        .filter(member => member?.status !== 9)
                        .map((member) => {
                        let mfcClientNumber = ""
                        let genderMfc = ""

                        if (member.data_operators.length > 0 && member.data_operators[0]?.hasOwnProperty("operator")) {
                            mfcClientNumber = member?.data_operators?.find(o => o.operator === MFC_OPERATOR)?.entity_data?.operator_store_id
                            genderMfc = member?.data_operators?.find(o => o.operator === MFC_OPERATOR)?.entity_data?.operator_gender
                        }

                        // Extra data for export file
                        const isFub = normalizeBoolean(member?.data_operators?.find(oneOperator => oneOperator.operator === BC_OPERATOR)?.entity_data?.is_member_fub?.toString())

                        return ({
                            createDate: member?.create_date,
                            social_reason: member?.entity_data?.raison_sociale,
                            commercial_name: member?.entity_data?.nom_commercial,
                            siret: member?.entity_data?.siret,
                            address: member?.entity_data?.adresse?.numero_et_voie,
                            postal_code: member?.entity_data?.adresse?.code_postal,
                            town: member?.entity_data?.adresse?.ville,
                            client_number: member?.entity_id,
                            email: member?.entity_data?.mail,
                            prenom_representant_legal: member?.entity_data?.prenom_representant_legal,
                            nom_representant_legal: member?.entity_data?.nom_representant_legal,
                            phone: member?.entity_data?.telephone_1?.replace("+33", "0"),
                            operators: member?.entity_data?.entity_permission?.operateurs,
                            mfc_client_number: mfcClientNumber || "",
                            gender_mfc: genderMfc || "",

                            // Extra data for export file
                            gender: genderStoreList.find(g => g.value === member?.gender)?.label,
                            isFranchise: member?.entity_data?.est_une_chaine ? "Oui" : "Non",
                            structureChainName: member?.entity_data?.nom_chaine || "",
                            isFubMember: isFub ? "Oui" : "Non",

                            // new property "keywords" : texts without accents for searching
                            keywords: member?.entity_data?.raison_sociale?.normalize("NFD").replace(/\p{Diacritic}/gu, "") + " " + member?.entity_data?.nom_commercial?.normalize("NFD").replace(/\p{Diacritic}/gu, "")
                        })
                    })
                    setPartners(newPartners)
                } catch (error) {
                    console.error(error)
                    const erroMsg = error?.message?.toString()
                    if (erroMsg) alert("error", erroMsg)

                    if (["Access token is required."].includes(error?.error?.message)) logout()

                }
            })()
        },
        [] // eslint-disable-line
    )

    // fetch data on first load
    React.useEffect(() => fetchData(), []) // eslint-disable-line

    return (
        <ProtectedLayout className="px-7 py-7">
            <div className="l-container">
                <div className="c-section-title mb-7">
                    <div className="c-section-title__content">
                        <DashboardIcon size={40} />
                        <h1 className="c-section-title__title c-h2 text-primary font-medium ml-5">
                            {t("list.title", { ns: "partner" }) }
                        </h1>
                    </div>
                </div>

                <p className=" mb-7">{t("list.description", { ns: "partner" }) }</p>

                {partners &&
                    <div className="c-card p-5 md:p-12">
                        <PartnersTable
                            data={partners}
                            isAdmin={OCODE_GENDERS_LIST.includes(entity?.gender) && user?.permission === 0} // O°Code Tech / Supp
                            className="pb-7"
                        />
                    </div>
                }

                {!partners &&
                    <div className="flex justify-center mt-24">
                        <div className="c-spinner"></div>
                    </div>
                }
            </div>
        </ProtectedLayout>
    )
}
